import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const BridesmaidSelection = () => {
  const { isAuthenticated, isLoading, user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, isLoading, navigate]);

  const bridesmaids = [
    {
      name: 'Kate',
      route: 'kate',
      image: '/images/bridesmaids/kate.jpg',
    },
    {
      name: 'Lala',
      route: 'lala',
      image: '/images/bridesmaids/lala.jpg',
    },
    {
      name: 'Lu',
      route: 'lu',
      image: '/images/bridesmaids/lu.jpg',
    },
    {
      name: 'Andy',
      route: 'andy',
      image: '/images/bridesmaids/andy.jpg',
    },
    {
      name: 'Pau',
      route: 'pau',
      image: '/images/bridesmaids/pau.jpg',
    }
  ];

  if (isLoading) {
    return (
      <div className="bridesmaids-selection-page d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
          <p className="mt-3">Cargando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null; // Will redirect via useEffect
  }

  return (
    <div className="bridesmaids-selection-page">
      {/* Hero Section */}
      <div className="selection-hero-section d-flex align-items-center justify-content-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <motion.div 
                className="selection-card"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
              >
                <div className="selection-content text-center">
                  <h1 className="selection-title mb-4">
                    Elige Tu Dama de Honor
                  </h1>
                  <p className="selection-subtitle lead mb-5">
                    Selecciona una dama de honor para ver su propuesta personalizada
                  </p>

                  {/* Bridesmaids Grid */}
                  <div className="bridesmaids-grid">
                    {bridesmaids.map((bridesmaid, index) => (
                      <motion.div
                        key={bridesmaid.route}
                        className="bridesmaid-card"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.05, ease: "easeOut" }}
                        whileHover={{ scale: 1.03, y: -5 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <Link 
                          to={`/bridesmaids/${bridesmaid.route}`}
                          className="bridesmaid-link"
                        >
                          <div className="bridesmaid-image-container">
                            <img 
                              src={bridesmaid.image}
                              alt={`${bridesmaid.name} - Bridesmaid`}
                              className="bridesmaid-image"
                              onError={(e) => {
                                e.target.style.display = "none";
                                e.target.nextSibling.style.display = "flex";
                              }}
                            />
                            <div 
                              className="image-placeholder d-none"
                              style={{ 
                                minHeight: "200px", 
                                display: "flex", 
                                alignItems: "center", 
                                justifyContent: "center",
                                background: "linear-gradient(135deg, var(--primary-color), var(--secondary-color))",
                                borderRadius: "15px"
                              }}
                            >
                              <div className="text-white text-center">
                                <i className="fas fa-user fa-3x mb-2"></i>
                                <h5>{bridesmaid.name}</h5>
                              </div>
                            </div>
                            <div className="bridesmaid-overlay">
                              <div className="overlay-content">
                                <i className="fas fa-heart fa-2x mb-2"></i>
                                <p className="mb-0">Haz clic para ver la propuesta</p>
                              </div>
                            </div>
                          </div>
                          <div className="bridesmaid-info">
                            <h4 className="bridesmaid-name">{bridesmaid.name}</h4>                            
                          </div>
                        </Link>
                      </motion.div>
                    ))}
                  </div>

                  {/* Special Message */}
                  <motion.div 
                    className="special-message mt-5"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.3, ease: "easeOut" }}
                  >
                    <div className="message-card p-4">
                      <h3 className="message-title mb-3">
                        <i className="fas fa-heart me-2"></i>
                        Una Nota Especial
                      </h3>
                      <p className="message-text">
                        Cada una de ustedes tiene un lugar especial en mi corazón, y no puedo esperar a celebrar este hermoso día con todas ustedes a mi lado. ¡Gracias por ser amigas tan increíbles!
                      </p>
                    </div>
                  </motion.div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BridesmaidSelection;
